import React from 'react';
import { Container } from '@mui/material';
import SacolaForm from '../components/sacola/SacolaForm';

const SacolaCadastro: React.FC = () => {
  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      <SacolaForm />
    </Container>
  );
};

export default SacolaCadastro;
